export const SET_MATCH_DATA = (state, payload) => {
  payload.forEach(match => {
    var prod = state.products.find(x => x._id === match.PRODUCTID);
    prod.match = match;
  });
};
